<div class="metrics-progress-chart" #chartRef></div>
<div class="chart-shadow shadow-left" [class.is-scrollable]="isScrollable"></div>
<div class="chart-shadow shadow-right" [class.is-scrollable]="isScrollable"></div>
